import {
  align,
  textColor,
  textSize,
  truncate,
  weight
} from "./chunk-IY7VD4JL.js";
import {
  reset
} from "./chunk-TCD77MI5.js";
import {
  getPaddingProps
} from "./chunk-L7SHRNH5.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/components/Text.tsx
import { forwardRef, createElement } from "react";
import cn from "classnames";
var Text = forwardRef((_a, ref) => {
  var _b = _a, {
    as: component = "div",
    size = "base",
    truncate: truncate2,
    align: align2,
    weight: weight2,
    textColor: color,
    className: passedClassName
  } = _b, props = __objRest(_b, [
    "as",
    "size",
    "truncate",
    "align",
    "weight",
    "textColor",
    "className"
  ]);
  const [paddingClass, restProps] = getPaddingProps(props);
  const className = cn(reset, passedClassName, paddingClass, size !== "none" && textSize[size], align2 && align[align2], weight2 && weight[weight2], color && textColor[color], { [truncate]: truncate2 });
  return createElement(component, __spreadProps(__spreadValues({}, restProps), {
    className,
    ref
  }));
});

export {
  Text
};
//# sourceMappingURL=chunk-GIEK627K.js.map
